export default {
    identity: {},
    access_token: '',
    mail:'',
    username:'',
    roletype:'',
    rolename:'',
    error: false
}
